export default {
  features: {
    applicationItemsFillImeis: {
      button: 'IMEI ni to‘ldirish',
      modal: {
        title: "Quyidagi mahsulotlar uchun IMEI kodni to'ldiring",
        alert: "IMEI kod 15 ta raqamlardan iborat bo'lishi kerak",
        close: 'Yopish',
      },
      form: {
        firstImei: {
          placeholder: 'IMEI 1',
        },
        secondImei: {
          placeholder: 'IMEI 2',
        },
      },
      successMessage: 'IMEI muvaffaqiyati saqlandi',
    },
  },
};
